/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptStepStatusType } from './ScriptStepStatusType.js';
import {
    ScriptStepStatusTypeFromJSON,
    ScriptStepStatusTypeFromJSONTyped,
    ScriptStepStatusTypeToJSON,
} from './ScriptStepStatusType.js';

/**
 * 
 * @export
 * @interface CreateOrUpdateScriptStepStatusRequest
 */
export interface CreateOrUpdateScriptStepStatusRequest {
    /**
     * 
     * @type {ScriptStepStatusType}
     * @memberof CreateOrUpdateScriptStepStatusRequest
     */
    status?: ScriptStepStatusType;
}

/**
 * Check if a given object implements the CreateOrUpdateScriptStepStatusRequest interface.
 */
export function instanceOfCreateOrUpdateScriptStepStatusRequest(value: object): boolean {
    return true;
}

export function CreateOrUpdateScriptStepStatusRequestFromJSON(json: any): CreateOrUpdateScriptStepStatusRequest {
    return CreateOrUpdateScriptStepStatusRequestFromJSONTyped(json, false);
}

export function CreateOrUpdateScriptStepStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateScriptStepStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : ScriptStepStatusTypeFromJSON(json['status']),
    };
}

export function CreateOrUpdateScriptStepStatusRequestToJSON(value?: CreateOrUpdateScriptStepStatusRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': ScriptStepStatusTypeToJSON(value['status']),
    };
}

